import { Element, FoodType } from "./types";

export const startElements: Element[] = [
  Element.Animal,
  Element.Earth,
  Element.Furnace,
  Element.Ice,
  Element.Tool,
];

export const foodTypesMap: Record<Element, FoodType> = {
  [Element.BurnedSomething]: FoodType.Inedible,
  [Element.Reed]: FoodType.Plant,
  [Element.FishSoup]: FoodType.Animal,
  [Element.Koumiss]: FoodType.Milk,
  [Element.Surstromming]: FoodType.Animal,
  [Element.Bush]: FoodType.Plant,
  [Element.CottonCandy]: FoodType.Sweet,
  [Element.Eggnog]: FoodType.Sweet,
  [Element.IceTea]: FoodType.Drink,
  [Element.Kvass]: FoodType.Drink,
  [Element.Sushi]: FoodType.Animal,
  [Element.Baklava]: FoodType.Sweet,
  [Element.Pilaf]: FoodType.Meat,
  [Element.Muesli]: FoodType.Vegan,
  [Element.Gozinaki]: FoodType.Sweet,
  [Element.Mead]: FoodType.Drink,
  [Element.Gingerbread]: FoodType.Bakery,
  [Element.Manure]: FoodType.Inedible,
  [Element.Tree]: FoodType.Plant,
  [Element.Fondue]: FoodType.Milk,
  [Element.CremeBrulee]: FoodType.Sweet,
  [Element.Croissant]: FoodType.Bakery,
  [Element.HotDog]: FoodType.Fastfood,
  [Element.Hamburger]: FoodType.Fastfood,
  [Element.Popcorn]: FoodType.Fastfood,
  [Element.Communion]: FoodType.Other,
  [Element.Beer]: FoodType.Drink,
  [Element.Vodka]: FoodType.Drink,
  [Element.Brandy]: FoodType.Drink,
  [Element.Liqueur]: FoodType.Drink,
  [Element.Cider]: FoodType.Drink,
  [Element.Soda]: FoodType.Drink,
  [Element.Cola]: FoodType.Drink,
  [Element.MulledWine]: FoodType.Drink,
  [Element.GroundCoffee]: FoodType.Other,
  [Element.CocoaPowder]: FoodType.Other,
  [Element.CocoaBean]: FoodType.Plant,
  [Element.CoffeeBean]: FoodType.Plant,
  [Element.Shawerma]: FoodType.Fastfood,
  [Element.Animal]: FoodType.Animal,
  [Element.Earth]: FoodType.Inedible,
  [Element.Furnace]: FoodType.Inedible,
  [Element.Ice]: FoodType.Other,
  [Element.Tool]: FoodType.Inedible,
  [Element.Bacteria]: FoodType.Animal,
  [Element.Egg]: FoodType.Animal,
  [Element.Meat]: FoodType.Meat,
  [Element.Milk]: FoodType.Milk,
  [Element.Water]: FoodType.Drink,
  [Element.BoilingWater]: FoodType.Drink,
  [Element.Omelette]: FoodType.Animal,
  [Element.Kebab]: FoodType.Fastfood,
  [Element.Forcemeat]: FoodType.Meat,
  [Element.Kefir]: FoodType.Milk,
  [Element.Cream]: FoodType.Milk,
  [Element.Cheese]: FoodType.Milk,
  [Element.BlueCheese]: FoodType.Milk,
  [Element.BoiledEgg]: FoodType.Animal,
  [Element.Roast]: FoodType.Meat,
  [Element.CondensedMilk]: FoodType.Milk,
  [Element.Milkshake]: FoodType.Drink,
  [Element.Fish]: FoodType.Animal,
  [Element.Seed]: FoodType.Plant,
  [Element.Grass]: FoodType.Plant,
  [Element.Sugar]: FoodType.Other,
  [Element.Sausage]: FoodType.Meat,
  [Element.Tea]: FoodType.Drink,
  [Element.Cutlet]: FoodType.Meat,
  [Element.Toffee]: FoodType.Sweet,
  [Element.IceCream]: FoodType.Sweet,
  [Element.FriedFish]: FoodType.Animal,
  [Element.Cereal]: FoodType.Plant,
  [Element.Mojito]: FoodType.Drink,
  [Element.Spices]: FoodType.Other,
  [Element.Flower]: FoodType.Plant,
  [Element.Caramel]: FoodType.Sweet,
  [Element.Syrup]: FoodType.Sweet,
  [Element.ButterDough]: FoodType.Bakery,
  [Element.Flour]: FoodType.Other,
  [Element.Porridge]: FoodType.Vegan,
  [Element.Berry]: FoodType.Vegan,
  [Element.Sauce]: FoodType.Other,
  [Element.Nut]: FoodType.Vegan,
  [Element.Honey]: FoodType.Animal,
  [Element.Candy]: FoodType.Sweet,
  [Element.Cookie]: FoodType.Bakery,
  [Element.Pie]: FoodType.Bakery,
  [Element.Cake]: FoodType.Bakery,
  [Element.Dough]: FoodType.Bakery,
  [Element.Juice]: FoodType.Drink,
  [Element.Wine]: FoodType.Drink,
  [Element.Jam]: FoodType.Sweet,
  [Element.Yogurt]: FoodType.Milk,
  [Element.Marshmallow]: FoodType.Sweet,
  [Element.Mayonnaise]: FoodType.Other,
  [Element.Fruit]: FoodType.Vegan,
  [Element.NutButter]: FoodType.Other,
  [Element.Mustard]: FoodType.Other,
  [Element.Topping]: FoodType.Other,
  [Element.Bread]: FoodType.Bakery,
  [Element.Pita]: FoodType.Bakery,
  [Element.Baozi]: FoodType.Bakery,
  [Element.Spaghetti]: FoodType.Bakery,
  [Element.Noodles]: FoodType.Bakery,
  [Element.Alcohol]: FoodType.Drink,
  [Element.Cocoa]: FoodType.Drink,
  [Element.Chocolate]: FoodType.Sweet,
  [Element.Coffee]: FoodType.Drink,
  [Element.Latte]: FoodType.Drink,
  [Element.Vegetable]: FoodType.Vegan,
  [Element.Toast]: FoodType.Bakery,
  [Element.Sandwich]: FoodType.Fastfood,
  [Element.HotChocolate]: FoodType.Drink,
  [Element.Eskimo]: FoodType.Sweet,
  [Element.ChocolateBar]: FoodType.Sweet,
  [Element.Muffin]: FoodType.Bakery,
  [Element.FrenchFries]: FoodType.Fastfood,
  [Element.Salad]: FoodType.Vegan,
  [Element.Soup]: FoodType.Vegan,
  [Element.Ketchup]: FoodType.Other,
};

export const elementsLength = Object.keys(foodTypesMap).length;
